module.exports = __webpack_public_path__ + "img/assessment-complete.738daadd.jpg";